import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";
import { APPLICANT } from "app/constants/apiEndPoints";

interface ResendOtpRequest {
  id: string;
}

interface ResendOtpResponse {
  message: string;
}

const resendOtp = async ({
  id,
}: ResendOtpRequest): Promise<ResendOtpResponse> => {
  const response = await httpRequest.post<ResendOtpResponse>(
    `${APPLICANT}/${id}/resend-otp`
  );
  return response.data;
};

export const useResendOtp = () => {
  return useMutation<ResendOtpResponse, Error, ResendOtpRequest>({
    mutationFn: resendOtp,
  });
};
